export enum UnsubscribeTypeEnum {
  unsubscribe_all_marketing_emails = 'marketing_emails',
  unsubscribe_campaign = 'unsubscribe_campaign',
}
